// Öffentliche API des Harmonika-Widgets (geteilt von der Griff-Visualisierung UND dem
// Keyboard-Simulator unter `features/keyboard`). Einzige Quelle der Knopf-/Ton-Tabelle und der
// generischen Korpus-/Knopf-Komponenten.
export {default as HarmonikaButton} from './HarmonikaButton.vue'
export {default as InstrumentBody} from './InstrumentBody.vue'
export {default as BassLayoutEditor} from './BassLayoutEditor.vue'
export {
  RAW_DATA,
  PRECALC_DATA,
  DEFAULT_KEY_MAPPINGS,
  STORAGE_KEY,
  DEFAULT_BASS_LAYOUT,
  BASS_LAYOUT_PRESETS,
  cloneBassLayout,
  INSTRUMENT_TUNINGS,
  instrumentTuning,
  buttonMidis,
  buttonNoteLabel,
} from './instrumentData'
export {bassSyllables, isBassChordButton} from './bassLayout'
export {parseNoteStr, formatNoteForDisplay, midiToFreq, transposedNoteLabel} from './noteParse'
export type {
  BellowsDirection,
  ButtonMapping,
  InstrumentTuning,
  RowData,
  PrecalcButton,
  PrecalcRow,
} from './harmonika.types'
